export const state = () => ({
  isOpen: false,
  settings: {},
});

export const mutations = {
  open: function (state, settings) {
    state.isOpen = true;
    state.settings = settings;
  },
  close: function (state) {
    state.isOpen = false;
  },
};

/*
settings = {
    reachGoal: string
}
 */
